import { create } from "zustand";

export interface MemberPrice {
  id: number;
  distance: string;
  categoryId: number | null;
  price: number;
  jerseySize: string;
}

interface Store {
  memberPrices: Record<string, MemberPrice>;
  setMemberPrices: (
    update:
      | Record<string, MemberPrice>
      | ((prev: Record<string, MemberPrice>) => Record<string, MemberPrice>)
  ) => void;
  removeMemberPrice: (id: string) => void;
}

export const useMarathonCartStoreD = create<Store>((set) => ({
  memberPrices: {},
  setMemberPrices: (update) => {
    set((state) => {
      const nextMemberPrices =
        typeof update === "function" ? update(state.memberPrices) : update;
      return { memberPrices: nextMemberPrices };
    });
  },
  removeMemberPrice: (id: string) =>
    set((state) => {
      const newMemberPrices = { ...state.memberPrices };
      delete newMemberPrices[id];
      return { memberPrices: newMemberPrices };
    }),
}));
